import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { AWARD_LABELS, AWARD_KEYS, QB_ADMIN_PASSWORD } from './qbAwards';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function QBAwardsAdmin({ roster, currentWeek }) {
  const [week, setWeek] = useState(currentWeek || 1);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/qb/awards/${week}`).then(r => setForm(r.data)).catch(() => setForm({}));
  }, [week]);

  const save = async () => {
    setSaving(true);
    try {
      const body = Object.fromEntries(AWARD_KEYS.map(k => [k, form[k] || null]));
      await axios.post(`${API}/qb/awards/${week}?password=${encodeURIComponent(QB_ADMIN_PASSWORD)}`, body);
      toast.success(`Week ${week} awards saved`);
    } catch (e) {
      toast.error('Failed to save awards');
    } finally {
      setSaving(false);
    }
  };

  const active = roster.filter(qb => !qb.injury_status);

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg" data-testid="qb-awards-admin">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-bold text-[#001f3f]">Weekly Awards</h3>
        <select value={week} onChange={e => setWeek(parseInt(e.target.value))} className="border rounded px-3 py-2" data-testid="awards-week-select">
          {Array.from({ length: Math.max(currentWeek || 1, 1) + 1 }, (_, i) => i).map(w => <option key={w} value={w}>Week {w}</option>)}
        </select>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {AWARD_KEYS.map(k => (
          <label key={k} className="block">
            <span className="text-sm font-medium text-slate-700">{AWARD_LABELS[k]}</span>
            <select
              value={form[k] || ''}
              onChange={e => setForm(f => ({ ...f, [k]: e.target.value || null }))}
              className="mt-1 w-full border rounded px-3 py-2"
              data-testid={`award-select-${k}`}
            >
              <option value="">— None —</option>
              {active.map(qb => <option key={qb.player_id} value={qb.player_id}>{qb.name} ({qb.school})</option>)}
            </select>
          </label>
        ))}
      </div>
      <Button onClick={save} disabled={saving} className="mt-4 bg-[#001f3f] text-white" data-testid="save-awards-btn">
        {saving ? 'Saving...' : 'Save Awards'}
      </Button>
    </div>
  );
}
